<div class="container-fluid py-5">
    <!-- For demo purpose -->
    <div class="row mb-4">
        <div class="col-lg-8 mx-auto text-center">
            <h1 class="display-6 "> Individual Education Session</h1>
        </div>

    </div> <!-- End -->
    <div class="row">
        <div class="col-lg-12 mx-auto">
            <mat-card class="card ">
<!--<prettyjson [obj]="form.value"></prettyjson>-->
                <form role="form" [formGroup]="form">
                    <div class="row">
                        <!*--------------------------------------------- Centre Name
                        --------------------------------------------->
<!--                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
<!--                            <mat-label>Centre Name</mat-label>-->


<!--                            <mat-select aria-label="Default select example" [formControl]="centreSelect"-->
<!--                                        (selectionChange)="onCentreSelect($event)">-->
<!--&lt;!&ndash;                                <mat-form-field appearance="outline" style="width:100%">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <mat-label>Search </mat-label>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <input matInput type="text" [(ngModel)]="centreQuery" (input)="filterCentres()">&ndash;&gt;-->
<!--&lt;!&ndash;                                </mat-form-field>&ndash;&gt;-->
<!--                                <mat-option *ngFor="let c of mFilteredCentreOptions|async"-->
<!--                                            [value]="c">{{c.centreName}}</mat-option>-->
<!--                            </mat-select>-->
<!--                            <mat-error *ngIf=" CenterName?.invalid  &&  (CenterName?.touched || CenterName?.dirty)">-->
<!--                                <mat-error style="color: red;" *ngIf="CenterName?.errors?.required">*Centre Name is-->
<!--                                    Required.-->
<!--                                </mat-error>-->
<!--                                <mat-error style="color: red;" *ngIf="CenterName?.errors?.pattern">*Enter Only-->
<!--                                    characters.-->
<!--                                </mat-error>-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->

                      <app-searchable-select class="col-md-4"
                                             [options]="centres$ | async"
                                             [selectedValue]="selectedCentre"
                                             [displayWithFn]="displayCentre"
                                             [placeholder]="'Select Centre'"
                                             [label]="'Select Centre'"
                                             (selectionChange)="onCentreSelect($event)"
                      ></app-searchable-select>


                        <!*--------------------------------------------- Name Of
                        Student--------------------------------------------->
<!--                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
<!--                            <mat-label>Name of the Student</mat-label>-->
<!--                            <mat-select aria-label="Default select example" [formControl]="childSelect"-->
<!--                                        (selectionChange)="onChildSelect($event)">-->
<!--                                <mat-option *ngFor="let c of (childData)" [ngClass]="{'yellow' : c.isAlloted==false}"-->
<!--                                            [value]="c">-->
<!--                                  <div class="option-row">-->
<!--                                    <span class="child-name">{{ c.firstName }} {{ c.lastName }} </span>-->
<!--                                    <span class="child-age"> → Age: {{ c.age }}</span>-->
<!--                                  </div>-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                            <mat-error-->
<!--                                    *ngIf=" form.controls.childCode?.invalid  &&  (form.controls.childCode?.touched || form.controls.childCode?.dirty)">-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.childCode?.errors?.required">*It is-->
<!--                                    Required.-->
<!--                                </mat-error>-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.childCode?.errors?.pattern">*Enter-->
<!--                                    Only characters.-->
<!--                                </mat-error>-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->

                      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                        <mat-label>Name of the Student</mat-label>

                        <mat-select
                          [formControl]="childSelect"
                          (selectionChange)="onChildSelect($event)"
                          (opened)="onDropdownOpen()">

                          <!-- Search Box -->
                          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
                            <div class="mat-select-search">
                              <input
                                matInput
                                placeholder="Search student..."
                                [formControl]="searchControl"
                                (keydown)="$event.stopPropagation()"
                                autocomplete="off"
                              />
                            </div>
                          </mat-option>

                          <!-- Filtered Options -->
                          <mat-option *ngFor="let c of filteredChildData"
                                      [value]="c"
                                      [ngClass]="{ 'yellow': c.isAlloted === false }">
                            <div class="option-row">
                              <span class="child-name">{{ c.firstName }} {{ c.lastName }}</span>
                              <span class="child-age"> → Age: {{ c.age }}</span>
                            </div>
                          </mat-option>

                        </mat-select>

                        <mat-error *ngIf="form.controls.childCode?.invalid && (form.controls.childCode?.touched || form.controls.childCode?.dirty)">
                          <span *ngIf="form.controls.childCode?.errors?.required">*It is Required.</span>
                          <span *ngIf="form.controls.childCode?.errors?.pattern">*Enter Only characters.</span>
                        </mat-error>
                      </mat-form-field>

                      <!* --Unit no-->


                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                            <mat-label> Unit no</mat-label>
                            <input matInput formControlName="unitCode"/>
                            <mat-error
                                    *ngIf=" form.controls.unitCode?.invalid  &&  (form.controls.unitCode?.touched || form.controls.subject?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.unitCode?.errors?.required">*It is
                                    Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.unitCode?.errors?.pattern">*Enter
                                    Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                        <!*---------------------------------------------Gender--------------------------------------------->
                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                            <mat-label>Select gender</mat-label>
                          <input matInput formControlName="gender" readonly>
                            <mat-error
                                    *ngIf=" form.controls.gender?.invalid  &&  (form.controls.gender?.touched || form.controls.gender?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.gender?.errors?.required">*It is
                                    Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.gender?.errors?.pattern">*Enter Only
                                    characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                        <!* ------- Follow up Child -->

                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                            <mat-label> Follow-up child</mat-label>
                            <mat-select aria-label="Default select example" formControlName=followUpChild>
                                <mat-option value="Yes">Yes</mat-option>
                                <mat-option value="No">No</mat-option>
                            </mat-select>
                            <mat-error
                                    *ngIf=" form.controls.followUpChild?.invalid  &&  (form.controls.subject?.touched || form.controls.followUpChild?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.followUpChild?.errors?.required">*It
                                    is Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.followUpChild?.errors?.pattern">
                                    *Enter Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                        <!--Attendance-->
                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                            <mat-label>Attendance</mat-label>

                            <mat-select formControlName="present" (selectionChange)="onAttendaceSelect($event)">
                                <mat-option value="Present">Present</mat-option>
                                <mat-option value="Absent">Absent</mat-option>
                            </mat-select>
                            <mat-error
                                    *ngIf=" form.controls.gender?.invalid  &&  (form.controls.gender?.touched || form.controls.gender?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.gender?.errors?.required">*It is
                                    Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.gender?.errors?.pattern">*Enter Only
                                    characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                        <!*--------------------------------------------- Type of session --------------------------------------------->
                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                            <mat-label>Type of session</mat-label>
                            <mat-select formControlName="sessionType" required (selectionChange)="onSessionTypeSelect($event)">
                                <mat-option value="Rapport Building">Rapport Building</mat-option>
                                <mat-option value="Baseline Assessment">Baseline Assessment</mat-option>
                                <mat-option value="Regular Study">Regular Study</mat-option>
                                <mat-option value="Intermediate Assessment">Intermediate Assessment</mat-option>
                                <mat-option value="Discharge Assessment">Discharge Assessment</mat-option>

                            </mat-select>
                            <mat-error
                                    *ngIf=" form.controls.sessionType?.invalid  &&  (form.controls.sessionType?.touched || form.controls.sessionType?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.sessionType?.errors?.required">*It
                                    is Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.sessionType?.errors?.pattern">*Enter
                                    Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                        <!*---------------------------------------------
                        Subject--------------------------------------------->
                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12" *ngIf="form.get('sessionType')?.value !=='Intermediate Assessment'">
                            <mat-label>Subject</mat-label>
                            <mat-select aria-label="Default select example" formControlName="subject" multiple>
                                <mat-option value="Language">Language</mat-option>
                                <mat-option value="Math">Maths</mat-option>
                                <mat-option value="EVS/GK">EVS/GK</mat-option>
                                <mat-option value="Activity">Activity</mat-option>
                                <mat-option value="NA">NA</mat-option>
                            </mat-select>
                            <mat-error
                                    *ngIf=" form.controls.subject?.invalid  &&  (form.controls.subject?.touched || form.controls.subject?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.subject?.errors?.required">*It is
                                    Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.subject?.errors?.pattern">*Enter
                                    Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12" *ngIf="form.get('sessionType')?.value =='Intermediate Assessment'">
                            <mat-label>Subject</mat-label>
                            <mat-select aria-label="Default select example" formControlName="subject">
                                <mat-option value="Language">Language</mat-option>
                                <mat-option value="Math">Maths</mat-option>
                                <mat-option value="EVS/GK">EVS/GK</mat-option>
                                <mat-option value="Activity">Activity</mat-option>
                                <mat-option value="NA">NA</mat-option>
                            </mat-select>
                            <mat-error
                                    *ngIf=" form.controls.subject?.invalid  &&  (form.controls.subject?.touched || form.controls.subject?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.subject?.errors?.required">*It is
                                    Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.subject?.errors?.pattern">*Enter
                                    Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                        <!*--Absent Reason-->
                        <mat-form-field *ngIf="form.controls.present.value=='Absent'" appearance="outline"
                                        class="col-md-4 col-sm-12">
                            <mat-label>Reason</mat-label>
                            <mat-select formControlName="absentReason">
                                <mat-option value="Hospitalised">Hospitalised</mat-option>
                                <mat-option value="In the center, but unwell">In the center, but unwell</mat-option>
                                <mat-option value="Hospital visit">Hospital visit</mat-option>
                                <mat-option value="Event at the center">Event at the centre</mat-option>
                                <mat-option value="Temp - Visit to hometown">Temp - Visit to hometown</mat-option>


                            </mat-select>
                            <mat-error
                                    *ngIf=" form.controls.absentReason?.invalid && form.controls.absentReason.value!=null  &&  (form.controls.absentReason?.touched || form.controls.absentReason?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.absentReason?.errors?.required">*It
                                    is Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.absentReason?.errors?.pattern">
                                    *Enter Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>


                        <!---->
                        <!*--------------------------------------------- DATE
                        --------------------------------------------->

                        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
                            <mat-label>Session conducted on</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="sessionDate" [max]="maxDate">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error
                                    *ngIf=" form.controls.sessionDate?.invalid  &&  (form.controls.sessionDate?.touched || form.controls.sessionDate?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.sessionDate?.errors?.required">*It
                                    is Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.sessionDate?.errors?.pattern">*Enter
                                    Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="col-12" appearance="outline" class="col-md-6 col-sm-12">
                            <mat-label>Start Time</mat-label>
                            <!-- The timepicker input -->
                            <input matTimepicker #t="matTimepicker" formControlName="startTime" [value]="startTimeValue"
                                   [strict]="false" id="timepicker-example" mode="12h"
                                   placeholder="Please select time..." name="time">
                            <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
                            <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
                            <!-- Error that will be shown when the input date is invalid -->
                            <mat-error *ngIf="startTime?.touched && startTime?.invalid">Invalid Time</mat-error>

                        </mat-form-field>

                        <!*--------------------------------------------- End Time --------------------------------------------->
                        <mat-form-field class="col-12" appearance="outline" class="col-md-6 col-sm-12">
                            <mat-label>End Time</mat-label>
                            <!-- The timepicker input -->
                            <input matTimepicker #t="matTimepicker" formControlName="endTime" [value]="endTimeValue"
                                   [strict]="false" id="end-time-picker" mode="12h"
                            >
                            <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
                            <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
                            <!-- Error that will be shown when the input date is invalid -->
                            <mat-error *ngIf="endTime?.touched && endTime?.invalid">Invalid Date</mat-error>
                        </mat-form-field>

<!--                        <!*-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; BASELINE MARKS -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment'" appearance="outline" class="col-md-4 col-sm-12">-->
<!--                            <mat-label>Language Level</mat-label>-->
<!--                            <mat-select formControlName="languageLevel" required>-->
<!--                                <mat-option value="Level 1">Level 1</mat-option>-->
<!--                                <mat-option value="Level 2">Level 2</mat-option>-->
<!--                                <mat-option value="Level 3">Level 3</mat-option>-->
<!--                                <mat-option value="Level 4">Level 4</mat-option>-->
<!--                                <mat-option value="Level 5">Level 5</mat-option>-->

<!--                            </mat-select>-->
<!--                            <mat-error-->
<!--                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' && form.controls.languageLevel?.invalid  &&  (form.controls.languageLevel?.touched || form.controls.languageLevel?.dirty)">-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.languageLevel?.errors?.required">*It-->
<!--                                    is Required.-->
<!--                                </mat-error>-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.languageLevel?.errors?.pattern">-->
<!--                                    *Enter-->
<!--                                    Only characters.-->
<!--                                </mat-error>-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment'" appearance="outline"-->
<!--                                        class="col-md-4 col-sm-12">-->
<!--                            <mat-label>Maths Level</mat-label>-->
<!--                            <mat-select formControlName="mathsLevel" required>-->
<!--                                <mat-option value="Level 1">Level 1</mat-option>-->
<!--                                <mat-option value="Level 2">Level 2</mat-option>-->
<!--                                <mat-option value="Level 3">Level 3</mat-option>-->
<!--                                <mat-option value="Level 4">Level 4</mat-option>-->
<!--                                <mat-option value="Level 5">Level 5</mat-option>-->

<!--                            </mat-select>-->
<!--                            <mat-error-->
<!--                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' && form.controls.mathsLevel?.invalid  &&  (form.controls.mathsLevel?.touched || form.controls.mathsLevel?.dirty)">-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.mathsLevel?.errors?.required">*It-->
<!--                                    is Required.-->
<!--                                </mat-error>-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.mathsLevel?.errors?.pattern">*Enter-->
<!--                                    Only characters.-->
<!--                                </mat-error>-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment'" appearance="outline"-->
<!--                                        class="col-md-4 col-sm-12">-->
<!--                            <mat-label>EVS GK Level</mat-label>-->
<!--                            <mat-select formControlName="evsgkLevel" required>-->
<!--                                <mat-option value="Level 1">Level 1</mat-option>-->
<!--                                <mat-option value="Level 2">Level 2</mat-option>-->
<!--                                <mat-option value="Level 3">Level 3</mat-option>-->
<!--                                <mat-option value="Level 4">Level 4</mat-option>-->
<!--                                <mat-option value="Level 5">Level 5</mat-option>-->

<!--                            </mat-select>-->
<!--                            <mat-error-->
<!--                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' && form.controls.evsgkLevel?.invalid  &&  (form.controls.evsgkLevel?.touched || form.controls.evsgkLevel?.dirty)">-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.evsgkLevel?.errors?.required">*It-->
<!--                                    is Required.-->
<!--                                </mat-error>-->
<!--                                <mat-error style="color: red;" *ngIf="form.controls.evsgkLevel?.errors?.pattern">*Enter-->
<!--                                    Only characters.-->
<!--                                </mat-error>-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->

<!--                        <div class="p-3 ms-auto me-auto">-->
<!--                            <table *ngIf="TypeOfSession?.value=='Baseline Assessment'|| TypeOfSession?.value =='Discharge Assessment'" class="border ">-->
<!--                                <thead>-->
<!--                                <th scope="col" class="text-center">Language</th>-->
<!--                                <th scope="col" class="text-center">Maths</th>-->
<!--                                <th scope="col" class="text-center">EVS/GK</th>-->
<!--                                </thead>-->
<!--                                <tbody>-->
<!--                                <tr>-->
<!--                                    <td class="text-center">-->
<!--                                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'"-->
<!--                                                        appearance="outline">-->
<!--                                            <mat-label>-->
<!--                                                Written-->
<!--                                            </mat-label>-->
<!--                                            <input matInput formControlName="languageWritten" type="number" max="10">-->
<!--                                            <mat-error-->
<!--                                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment' && form.controls.languageWritten?.invalid  &&  (form.controls.languageWritten?.touched || form.controls.languageWritten?.dirty)">-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.languageWritten?.errors?.required">*It-->
<!--                                                    is Required.-->
<!--                                                </mat-error>-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.languageWritten?.errors?.pattern">*Enter-->
<!--                                                    Only characters.-->
<!--                                                </mat-error>-->
<!--                                            </mat-error>-->
<!--                                        </mat-form-field>-->

<!--                                    </td>-->
<!--                                    <td class="text-center">-->
<!--                                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'"-->
<!--                                                        appearance="outline">-->
<!--                                            <mat-label>-->
<!--                                                Written-->
<!--                                            </mat-label>-->
<!--                                            <input matInput formControlName="mathsWritten" type="number" max="10">-->
<!--                                            <mat-error-->
<!--                                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment' && form.controls.mathsWritten?.invalid  &&  (form.controls.mathsWritten?.touched || form.controls.mathsWritten?.dirty)">-->

<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.mathsWritten?.errors?.required">*It-->
<!--                                                    is Required.-->
<!--                                                </mat-error>-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.mathsWritten?.errors?.pattern">*Enter-->
<!--                                                    Only characters.-->
<!--                                                </mat-error>-->
<!--                                            </mat-error>-->
<!--                                        </mat-form-field>-->

<!--                                    </td>-->
<!--                                    <td class="text-center">-->
<!--                                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'"-->
<!--                                                        appearance="outline">-->
<!--                                            <mat-label>-->
<!--                                                Written-->
<!--                                            </mat-label>-->
<!--                                            <input matInput formControlName="evsgkWritten" type="number" max="10">-->
<!--                                            <mat-error-->
<!--                                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment' && form.controls.evsgkWritten?.invalid  &&  (form.controls.evsgkWritten?.touched || form.controls.evsgkWritten?.dirty)">-->

<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.evsgkWritten?.errors?.required">*It-->
<!--                                                    is Required.-->
<!--                                                </mat-error>-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.evsgkWritten?.errors?.pattern">*Enter-->
<!--                                                    Only characters.-->
<!--                                                </mat-error>-->
<!--                                            </mat-error>-->
<!--                                        </mat-form-field>-->

<!--                                    </td>-->
<!--                                </tr>-->
<!--                                <tr>-->
<!--                                    <td class="text-center">-->
<!--                                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'"-->
<!--                                                        appearance="outline">-->
<!--                                            <mat-label>-->
<!--                                                Oral-->
<!--                                            </mat-label>-->
<!--                                            <input matInput formControlName="languageOral" type="number" max="10">-->
<!--                                            <mat-error-->
<!--                                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment' && form.controls.languageOral?.invalid  &&  (form.controls.languageOral?.touched || form.controls.languageOral?.dirty)">-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.languageOral?.errors?.required">*It-->
<!--                                                    is Required.-->
<!--                                                </mat-error>-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.languageOral?.errors?.pattern">*Enter-->
<!--                                                    Only characters.-->
<!--                                                </mat-error>-->
<!--                                            </mat-error>-->
<!--                                        </mat-form-field>-->
<!--                                    </td>-->
<!--                                    <td class="text-center">-->
<!--                                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'"-->
<!--                                                        appearance="outline">-->
<!--                                            <mat-label>-->
<!--                                                Oral-->
<!--                                            </mat-label>-->
<!--                                            <input matInput formControlName="mathsOral" type="number" max="10">-->
<!--                                            <mat-error-->
<!--                                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment' && form.controls.mathsOral?.invalid  &&  (form.controls.mathsOral?.touched || form.controls.mathsOral?.dirty)">-->

<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.mathsOral?.errors?.required">*It-->
<!--                                                    is Required.-->
<!--                                                </mat-error>-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.mathsOral?.errors?.pattern">*Enter-->
<!--                                                    Only characters.-->
<!--                                                </mat-error>-->
<!--                                            </mat-error>-->
<!--                                        </mat-form-field>-->
<!--                                    </td>-->
<!--                                    <td class="text-center">-->
<!--                                        <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'"-->
<!--                                                        appearance="outline">-->
<!--                                            <mat-label>-->
<!--                                                Oral-->
<!--                                            </mat-label>-->
<!--                                            <input matInput formControlName="evsgkOral" type="number" max="10">-->
<!--                                            <mat-error-->
<!--                                                    *ngIf=" TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment' && form.controls.evsgkOral?.invalid  &&  (form.controls.evsgkOral?.touched || form.controls.evsgkOral?.dirty)">-->

<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.evsgkOral?.errors?.required">*It-->
<!--                                                    is Required.-->
<!--                                                </mat-error>-->
<!--                                                <mat-error style="color: red;"-->
<!--                                                           *ngIf="form.controls.evsgkOral?.errors?.pattern">*Enter-->
<!--                                                    Only characters.-->
<!--                                                </mat-error>-->
<!--                                            </mat-error>-->
<!--                                        </mat-form-field>-->
<!--                                    </td>-->

<!--                                </tr>-->
<!--                                <tr class="text-center">-->
<!--                                    <td class="text-center">-->
<!--                                        <div class=" center-vertical text-center"-->
<!--                                             *ngIf="TypeOfSession?.value=='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'">{{getLanguagePerc(this.form.get('languageOral')?.value, this.form.get('languageWritten')?.value)}}</div>-->

<!--                                    </td>-->
<!--                                    <td class="text-center">-->
<!--                                        <div class=" center-vertical text-center"-->
<!--                                             *ngIf="TypeOfSession?.value=='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'">{{getMathsPercentage(this.form.get('mathsOral')?.value, this.form.get('mathsWritten')?.value)}}</div>-->

<!--                                    </td>-->
<!--                                    <td class="text-center">-->
<!--                                        <div class=" center-vertical text-center"-->
<!--                                             *ngIf="TypeOfSession?.value=='Baseline Assessment' || TypeOfSession?.value =='Discharge Assessment'">{{getEvsGKPercentage(this.form.get('evsgkOral')?.value, this.form.get('evsgkWritten')?.value)}}</div>-->

<!--                                    </td>-->

<!--                                </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->
                      <!--------------------------------------------- BASELINE MARKS --------------------------------------------->
                      <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment'" appearance="outline" class="col-md-4 col-sm-12">
                        <mat-label>Language Level</mat-label>
                        <mat-select formControlName="languageLevel" required>
                          <mat-option value="Level 1">Level 1</mat-option>
                          <mat-option value="Level 2">Level 2</mat-option>
                          <mat-option value="Level 3">Level 3</mat-option>
                          <mat-option value="Level 4">Level 4</mat-option>
                          <mat-option value="Level 5">Level 5</mat-option>
                        </mat-select>
                        <mat-error *ngIf="(TypeOfSession?.value =='Baseline Assessment') && form.controls.languageLevel?.invalid && (form.controls.languageLevel?.touched || form.controls.languageLevel?.dirty)">
                          <mat-error style="color: red;" *ngIf="form.controls.languageLevel?.errors?.required">*It is Required.</mat-error>
                          <mat-error style="color: red;" *ngIf="form.controls.languageLevel?.errors?.pattern">*Enter Only characters.</mat-error>
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment'" appearance="outline" class="col-md-4 col-sm-12">
                        <mat-label>Maths Level</mat-label>
                        <mat-select formControlName="mathsLevel" required>
                          <mat-option value="Level 1">Level 1</mat-option>
                          <mat-option value="Level 2">Level 2</mat-option>
                          <mat-option value="Level 3">Level 3</mat-option>
                          <mat-option value="Level 4">Level 4</mat-option>
                          <mat-option value="Level 5">Level 5</mat-option>
                        </mat-select>
                        <mat-error *ngIf="(TypeOfSession?.value =='Baseline Assessment') && form.controls.mathsLevel?.invalid && (form.controls.mathsLevel?.touched || form.controls.mathsLevel?.dirty)">
                          <mat-error style="color: red;" *ngIf="form.controls.mathsLevel?.errors?.required">*It is Required.</mat-error>
                          <mat-error style="color: red;" *ngIf="form.controls.mathsLevel?.errors?.pattern">*Enter Only characters.</mat-error>
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="TypeOfSession?.value =='Baseline Assessment'" appearance="outline" class="col-md-4 col-sm-12">
                        <mat-label>EVS GK Level</mat-label>
                        <mat-select formControlName="evsgkLevel" required>
                          <mat-option value="Level 1">Level 1</mat-option>
                          <mat-option value="Level 2">Level 2</mat-option>
                          <mat-option value="Level 3">Level 3</mat-option>
                          <mat-option value="Level 4">Level 4</mat-option>
                          <mat-option value="Level 5">Level 5</mat-option>
                        </mat-select>
                        <mat-error *ngIf="(TypeOfSession?.value =='Baseline Assessment' || TypeOfSession?.value =='Intermediate Assessment') && form.controls.evsgkLevel?.invalid && (form.controls.evsgkLevel?.touched || form.controls.evsgkLevel?.dirty)">
                          <mat-error style="color: red;" *ngIf="form.controls.evsgkLevel?.errors?.required">*It is Required.</mat-error>
                          <mat-error style="color: red;" *ngIf="form.controls.evsgkLevel?.errors?.pattern">*Enter Only characters.</mat-error>
                        </mat-error>
                      </mat-form-field>

                      <div class="p-3 ms-auto me-auto" *ngIf="TypeOfSession?.value !=='Intermediate Assessment'">
                        <table *ngIf="['Baseline Assessment', 'Discharge Assessment'].includes(TypeOfSession?.value)" class="border">
                          <thead>
                          <th scope="col" class="text-center">Language</th>
                          <th scope="col" class="text-center">Maths</th>
                          <th scope="col" class="text-center">EVS/GK</th>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="text-center">
                              <mat-form-field *ngIf="['Baseline Assessment', 'Discharge Assessment', 'Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Written</mat-label>
                                <input matInput formControlName="languageWritten" type="number" max="10">
                                <mat-error *ngIf="form.controls.languageWritten?.invalid && (form.controls.languageWritten?.touched || form.controls.languageWritten?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.languageWritten?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.languageWritten?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                              </mat-form-field>
                            </td>

                            <td class="text-center">
                              <mat-form-field *ngIf="['Baseline Assessment', 'Discharge Assessment', 'Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Written</mat-label>
                                <input matInput formControlName="mathsWritten" type="number" max="10">
                                <mat-error *ngIf="form.controls.mathsWritten?.invalid && (form.controls.mathsWritten?.touched || form.controls.mathsWritten?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsWritten?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsWritten?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                              </mat-form-field>
                            </td>

                            <td class="text-center">
                              <mat-form-field *ngIf="['Baseline Assessment', 'Discharge Assessment', 'Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Written</mat-label>
                                <input matInput formControlName="evsgkWritten" type="number" max="10">
                                <mat-error *ngIf="form.controls.evsgkWritten?.invalid && (form.controls.evsgkWritten?.touched || form.controls.evsgkWritten?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkWritten?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkWritten?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                              </mat-form-field>
                            </td>
                          </tr>

                          <tr>
                            <td class="text-center">
                              <mat-form-field *ngIf="['Baseline Assessment', 'Discharge Assessment', 'Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Oral</mat-label>
                                <input matInput formControlName="languageOral" type="number" max="10">
                                <mat-error *ngIf="form.controls.languageOral?.invalid && (form.controls.languageOral?.touched || form.controls.languageOral?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.languageOral?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.languageOral?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                              </mat-form-field>
                            </td>

                            <td class="text-center">
                              <mat-form-field *ngIf="['Baseline Assessment', 'Discharge Assessment', 'Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Oral</mat-label>
                                <input matInput formControlName="mathsOral" type="number" max="10">
                                <mat-error *ngIf="form.controls.mathsOral?.invalid && (form.controls.mathsOral?.touched || form.controls.mathsOral?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsOral?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsOral?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                              </mat-form-field>
                            </td>

                            <td class="text-center">
                              <mat-form-field *ngIf="['Baseline Assessment', 'Discharge Assessment', 'Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Oral</mat-label>
                                <input matInput formControlName="evsgkOral" type="number" max="10">
                                <mat-error *ngIf="form.controls.evsgkOral?.invalid && (form.controls.evsgkOral?.touched || form.controls.evsgkOral?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkOral?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkOral?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                              </mat-form-field>
                            </td>
                          </tr>

                          <tr class="text-center">
                            <td>
                              <div *ngIf="['Baseline Assessment', 'Discharge Assessment'].includes(TypeOfSession?.value)">
                                {{getLanguagePerc(form.get('languageOral')?.value, form.get('languageWritten')?.value) | number:'1.2-2'}}
                              </div>
                            </td>
                            <td>
                              <div *ngIf="['Baseline Assessment', 'Discharge Assessment'].includes(TypeOfSession?.value)">
                                {{getMathsPercentage(form.get('mathsOral')?.value, form.get('mathsWritten')?.value) | number:'1.2-2'}}
                              </div>
                            </td>
                            <td>
                              <div *ngIf="['Baseline Assessment', 'Discharge Assessment'].includes(TypeOfSession?.value)">
                                {{getEvsGKPercentage(form.get('evsgkOral')?.value, form.get('evsgkWritten')?.value) | number:'1.2-2'}}
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="p-3 ms-auto me-auto" *ngIf="TypeOfSession?.value =='Intermediate Assessment' && form.get('subject')?.value">
                        <table *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" class="border">
                          <thead>
                          <th scope="col" class="text-center" *ngIf="form.get('subject')?.value === 'Language'">Language</th>
                          <th scope="col" class="text-center" *ngIf="form.get('subject')?.value === 'Math'">Maths</th>
                          <th scope="col" class="text-center" *ngIf="form.get('subject')?.value === 'EVS/GK'">EVS/GK</th>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="text-center" *ngIf="form.get('subject')?.value === 'Language'">
                              <mat-form-field *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Written</mat-label>
                                <input matInput formControlName="languageWritten" type="number" max="10">
                                <mat-error *ngIf="form.controls.languageWritten?.invalid && (form.controls.languageWritten?.touched || form.controls.languageWritten?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.languageWritten?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.languageWritten?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                                <mat-error *ngIf="form.errors?.languageScoreExceeded && form.get('subject')?.value === 'Language'">
                                  *Combined score of Written and Oral must not exceed 10.
                                </mat-error>
                              </mat-form-field>
                            </td>

                            <td class="text-center" *ngIf="form.get('subject')?.value === 'Math'">
                              <mat-form-field *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Written</mat-label>
                                <input matInput formControlName="mathsWritten" type="number" max="10">
                                <mat-error *ngIf="form.controls.mathsWritten?.invalid && (form.controls.mathsWritten?.touched || form.controls.mathsWritten?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsWritten?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsWritten?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                                <mat-error *ngIf="form.errors?.mathScoreExceeded && form.get('subject')?.value === 'Math'">
                                  *Combined score of Written and Oral must not exceed 10.
                                </mat-error>

                              </mat-form-field>
                            </td>

                            <td class="text-center" *ngIf="form.get('subject')?.value === 'EVS/GK'">
                              <mat-form-field *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Written</mat-label>
                                <input matInput formControlName="evsgkWritten" type="number" max="10">
                                <mat-error *ngIf="form.controls.evsgkWritten?.invalid && (form.controls.evsgkWritten?.touched || form.controls.evsgkWritten?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkWritten?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkWritten?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                                <mat-error *ngIf="form.errors?.evsgkScoreExceeded && form.get('subject')?.value === 'EVS/GK'">
                                  *Combined score of Written and Oral must not exceed 10.
                                </mat-error>

                              </mat-form-field>
                            </td>
                          </tr>

                          <tr>
                            <td class="text-center" *ngIf="form.get('subject')?.value === 'Language'">
                              <mat-form-field *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Oral</mat-label>
                                <input matInput formControlName="languageOral" type="number" max="10">
                                <mat-error *ngIf="form.controls.languageOral?.invalid && (form.controls.languageOral?.touched || form.controls.languageOral?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.languageOral?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.languageOral?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                                <mat-error *ngIf="form.errors?.languageScoreExceeded && form.get('subject')?.value === 'Language'">
                                  *Combined score of Written and Oral must not exceed 10.
                                </mat-error>

                              </mat-form-field>
                            </td>

                            <td class="text-center" *ngIf="form.get('subject')?.value === 'Math'">
                              <mat-form-field *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Oral</mat-label>
                                <input matInput formControlName="mathsOral" type="number" max="10">
                                <mat-error *ngIf="form.controls.mathsOral?.invalid && (form.controls.mathsOral?.touched || form.controls.mathsOral?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsOral?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.mathsOral?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                                <mat-error *ngIf="form.errors?.mathScoreExceeded && form.get('subject')?.value === 'Math'">
                                  *Combined score of Written and Oral must not exceed 10.
                                </mat-error>

                              </mat-form-field>
                            </td>

                            <td class="text-center" *ngIf="form.get('subject')?.value === 'EVS/GK'">
                              <mat-form-field *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)" appearance="outline">
                                <mat-label>Oral</mat-label>
                                <input matInput formControlName="evsgkOral" type="number" max="10" >
                                <mat-error *ngIf="form.controls.evsgkOral?.invalid && (form.controls.evsgkOral?.touched || form.controls.evsgkOral?.dirty)">
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkOral?.errors?.required">*It is Required.</mat-error>
                                  <mat-error style="color: red;" *ngIf="form.controls.evsgkOral?.errors?.pattern">*Enter Only characters.</mat-error>
                                </mat-error>
                                <mat-error *ngIf="form.errors?.evsgkScoreExceeded && form.get('subject')?.value === 'EVS/GK'">
                                  *Combined score of Written and Oral must not exceed 10.
                                </mat-error>

                              </mat-form-field>
                            </td>
                          </tr>
                          <mat-error *ngIf="form.errors?.languageScoreExceeded && form.get('subject')?.value === 'Language'">
                            *Combined score of Written and Oral must not exceed 10.
                          </mat-error>
                          <mat-error *ngIf="form.errors?.mathScoreExceeded && form.get('subject')?.value === 'Math'">
                            *Combined score of Written and Oral must not exceed 10.
                          </mat-error>
                          <mat-error *ngIf="form.errors?.evsgkScoreExceeded && form.get('subject')?.value === 'EVS/GK'">
                            *Combined score of Written and Oral must not exceed 10.
                          </mat-error>

                          <tr class="text-center">
                            <td *ngIf="form.get('subject')?.value === 'Language'">
                              <div *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)">
                                {{getLanguagePerc(form.get('languageOral')?.value, form.get('languageWritten')?.value)| number:'1.2-2'}} %
                              </div>
                            </td>
                            <td *ngIf="form.get('subject')?.value === 'Math'">
                              <div *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)">
                                {{getMathsPercentage(form.get('mathsOral')?.value, form.get('mathsWritten')?.value) | number:'1.2-2'}} %
                              </div>
                            </td>
                            <td *ngIf="form.get('subject')?.value === 'EVS/GK'">
                              <div *ngIf="['Intermediate Assessment'].includes(TypeOfSession?.value)">
                                {{getEvsGKPercentage(form.get('evsgkOral')?.value, form.get('evsgkWritten')?.value)| number:'1.2-2'}} %
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>


                        <!*--------------------------------------------- Topics Covered --------------------------------------------->
                        <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
                            <mat-label data-toggle="tooltip">Topic covered in session</mat-label>
                            <input type="text" matInput required formControlName="topicsCovered"
                                   (blur)="onBlur(form.controls.topicsCovered)">
                            <mat-error
                                    *ngIf=" form.controls.topicsCovered?.invalid  &&  (form.controls.topicsCovered?.touched || form.controls.topicsCovered?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.topicsCovered?.errors?.required">*It
                                    is Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.topicsCovered?.errors?.pattern">
                                    *Enter Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                        <!*--------------------------------------------- Session Details --------------------------------------------->
                        <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
                            <mat-label data-toggle="tooltip" title="">Session details</mat-label>
                            <textarea matInput id="textAreaExample" rows="4"
                                      formControlName="sessionDetails"
                                      (blur)="onBlur(form.controls.sessionDetails)"></textarea>
                            <mat-error
                                    *ngIf=" form.controls.sessionDetails?.invalid  &&  (form.controls.sessionDetails?.touched || form.controls.sessionDetails?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.sessionDetails?.errors?.required">
                                    *It is Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.sessionDetails?.errors?.pattern">
                                    *Enter Only characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                        <!*---------------------------------------------
                        Remark--------------------------------------------->
                        <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
                            <mat-label data-toggle="tooltip">Performance</mat-label>
                            <mat-select formControlName="remark">
                              <mat-option value="Well Done"> Well Done</mat-option>
                              <mat-option value="Very Good"> Very Good</mat-option>
                              <mat-option value="Good"> Good</mat-option>
                              <mat-option value="Fair"> Fair</mat-option>
                              <mat-option value="Can do better"> Can do better</mat-option>
                            </mat-select>

                            <mat-error
                                    *ngIf=" form.controls.remark?.invalid  &&  (form.controls.remark?.touched || form.controls.remark?.dirty)">
                                <mat-error style="color: red;" *ngIf="form.controls.remark?.errors?.required">*It is
                                    Required.
                                </mat-error>
                                <mat-error style="color: red;" *ngIf="form.controls.remark?.errors?.pattern">*Enter Only
                                    characters.
                                </mat-error>
                            </mat-error>
                        </mat-form-field>

                                        <!--       Conducted By               -->

                      <mat-form-field appearance="outline" class="col-md-6" >
                        <mat-label>Conducted By</mat-label>
                        <mat-select formControlName="conductedBy" (selectionChange)="OnConductedByChange($event)">
                          <mat-option value="By Teacher">By Teacher</mat-option>
                          <mat-option value="By Volunteer">By Volunteer</mat-option>
                        </mat-select>
                      </mat-form-field>

                        <mat-form-field appearance="outline" class="col-md-6" *ngIf="showVolunteerName" >
                        <mat-label>Volunteer Name</mat-label>
                        <mat-select formControlName="volunteerName" >
                          <mat-option *ngFor="let volunteer of mVolunteers$|async" [value]="volunteer">{{volunteer}}</mat-option>

                        </mat-select>
                      </mat-form-field>

                        <!--                                            <prettyjson [obj]="userData"></prettyjson>-->

                        <div class="col-4" *ngIf="formSaved">
                            <app-upload [path]="docpath" [dbType]="dbType" [storagePath]="storagePath"></app-upload>
                        </div>

                        <div class="d-flex justify-content-center mt-3 mb-4 gap-2">
                          <button mat-raised-button color="primary"
                                  type="button"
                                  class="btn btn-success"
                                  [disabled]="form.invalid || isLoading"
                                  (click)="Submit()">

                            <ng-container *ngIf="isLoading; else saveText">
                              <mat-spinner diameter="20"></mat-spinner>
                            </ng-container>

                            <ng-template #saveText>Save</ng-template>
                          </button>

                          <button mat-raised-button color="warn" type="button" class="btn btn-danger"
                                    (click)="close()">Cancel
                            </button>
                        </div>
                    </div>
                </form>
<!--                                <prettyjson [obj]="form.getRawValue()"></prettyjson>-->

            </mat-card>
        </div>
    </div>
<!--    <prettyjson [obj]="form.getRawValue()"></prettyjson>-->

</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
